export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EditDate.vue?vue&type=template&id=8961c9d2&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Agenda/EditDate.vue?vue&type=template&id=8961c9d2&
// module id = 422
// module chunks = 0